import { Modal, Text, View, type GestureResponderEvent } from 'react-native';
import Translations from 'src/core/utils/Translations';
import { PrimaryButton, SecondaryButton } from 'src/presentation/components/molecules/Button';
import dialogStyles from 'src/presentation/dialogs/styles/DialogStyles';
import Dimens from 'src/core/utils/Dimens';

interface Props {
	buttonText?: string;
	buttonTextClaim?: string;
	isLoading?: boolean;
	onPress: (event: GestureResponderEvent) => void;
	onPressClaim?: (event: GestureResponderEvent) => void;
	text?: string;
	title?: string;
	visible?: boolean;
}

const ConfirmationDialog = ({
	buttonText = Translations.cancel,
	buttonTextClaim,
	isLoading = false,
	onPress,
	onPressClaim,
	text,
	title,
	visible,
}: Props) => {
	return (
		<Modal animationType="fade" style={dialogStyles.modalView} transparent={true} visible={visible}>
			<View style={dialogStyles.centeredView}>
				<View style={dialogStyles.modalCard}>
					{title ? <Text style={dialogStyles.modalTitle}>{title}</Text> : null}
					{text ? <Text style={dialogStyles.modalDescription}>{text}</Text> : null}

					<View style={{ flexDirection: 'row' }}>
						<SecondaryButton
							extraStyle={{ paddingHorizontal: Dimens.padding10, flex: Dimens.flex1 }}
							label={buttonText}
							onPress={onPress}
						/>
						<PrimaryButton
							extraStyle={{ paddingHorizontal: Dimens.padding10, flex: Dimens.flex1 }}
							label={buttonTextClaim}
							loading={isLoading}
							onPress={onPressClaim}
						/>
					</View>
				</View>
			</View>
		</Modal>
	);
};

export default ConfirmationDialog;
